export const AppConstants = {
  ADD: 'Add',
  SAVE: 'Save',
  CLOSE: 'Close',
  ADDED: 'Added',
  RESULT: 'Result',
  SEARCH: 'Search',
  RESET: 'Reset',
  BACK: 'Back',
  HEADER_TITLE: 'Customer Research Tool',
  LOGOUT: 'Logout',
  LOADING: 'Loading...',
  SESSION_TIMEOUT: 'Session Timeout',
  OK: 'OK',
  MODAL_BODY_TEXT: 'Your session has timed out. Please click OK to continue.',
  DEFAULT_LANGUAGE: 'en',
  LOGIN: {
    LOGIN_HEADING: 'Login',
    USER_ID: 'User ID',
  },
  SOURCE_POP_UP : {
    NAME: 'Name',
    ID_TYPE: 'ID Type',
    ID_VALUE: 'ID Value',
    EXPIRE_DATE: 'Expiry Date',
    SOURCE:'Source'
  },
  COLUMN_SECTION_POP_UP: {
    ALL_COLUMN: 'All Columns',
    SELECTED_COLUMNS: 'Selected Columns',
  },
  RESULT_PROFILE: {
    SEARCH_PARAMETER: 'Search Parameters:',
    GO_BACK: 'Back',
    COLUMN_SETTINGS: 'Column Settings',
    SANOFI_PROFILE: 'Sanofi Profile',
    SELECT_SOURCES: 'Select Source',
    SOURCE_CROSS_REFERENCE: 'Source Cross Reference',
    DEA: 'DEA Expired',
    SOURCE_ID: 'Source ID',
    SOURCE_ADDRESS: 'Source Address',
    NORMALIZED_ADDRESS: 'Normalized Address',
    EXPORT_BULK_SEARCH: 'Export Bulk Search',
    SELECT_CRITERIA:'Criteria'
  },
  SEARCH_PROFILE: {
    SEARCH_CUSTOMER: 'Search Customer',
    TYPE: 'Type (HCA/HCP):',
    DEMOGRAPICS: 'Demographics',
    NAME: 'Name',
    VALID_NAME_ERROR: 'Please enter a valid name',
    ADDRESS: 'Address',
    VALID_ADDRESS_ERROR:'Please enter a valid address',
    CITY: 'City',
    VALID_CITY_ERROR: 'Please enter a valid city name',
    STATE: 'State',
    VALID_STATE_ERROR:'Please enter a valid state name',
    ZIP: 'ZIP',
    VALID_ZIP_ERROR: 'Please enter a valid zip code',
    INTERNAL_IDENTIFIERS: 'Internal Identifiers',
    RCM_ID: 'RCM ID',
    VALID_RCM_ERROR: 'Please enter a valid RCM id',
    SOURCE: 'Source',
    NOT_SELECTED: '-- Not Selected --',
    SOURCE_ID: 'Source ID',
    SOURCE_REQUIRED: 'Source is required.',
    VALID_SOURCE_ID_ERROR: 'Please enter a valid Source id',
    EXTERNAL_IDENTIFIERS: 'External Identifiers',
    DEA: 'DEA',
    VALID_DEA_ERROR: 'Please enter a valid DEA',
    HIN: 'HIN',
    VALID_HIN_ERROR: 'Please enter a valid HIN',
    EI_340B: '340B',
    VALID_EI_340B_ERROR: 'Please enter a valid 340B',
    NPI: 'NPI',
    VALID_NPI_ERROR: 'Please enter a valid NPI',
    SLN: 'SLN',
    VALID_SLN_ERROR: 'Please enter a valid SLN',
    TDDD: 'TDDD',
    VALID_TDDD_ERROR: 'Please enter a valid TDDD',
    HCCE: 'HCCE',
    VALID_HCCE_ERROR: 'Please enter a valid HCCE',
    VIEW_SEARCH_HISTORY: 'View Search History',
    SEARCH_HISTORY: 'Search History',
    BULK_SEARCH_BUTTON: 'Bulk Search'
  },
};
